import { MagneticButton, ParticleField } from '@/components/design-system';
import { useAuth } from '@pooflabs/web';
import { motion } from 'framer-motion';

const HERO_IMAGE_URL =
  'https://tarobase-app-storage-public-v2-prod.s3.amazonaws.com/tarobase-app-storage-697d5189a1e3dd2cc1a82d2b/6a5bd98f5c61a337c4518c8f';

export function Hero() {
  const { user, login } = useAuth();

  const handleCta = () => {
    if (!user) {
      login();
      return;
    }
    document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className='relative flex min-h-[100vh] w-full items-center justify-center overflow-hidden'>
      {/* Background layer — swappable to <video> later, structured identically */}
      <div className='absolute inset-0'>
        <img
          src={HERO_IMAGE_URL}
          alt=''
          className='h-full w-full animate-ken-burns object-cover opacity-75'
        />
        {/* Balanced scrim: dark enough at the top/bottom edges for legible type,
            but lets the photo read clearly through the middle instead of a flat heavy black wash. */}
        <div className='absolute inset-0 bg-gradient-to-b from-background/55 via-background/20 to-background/80' />
        {/* Soft vignette centered on the copy for extra contrast without flattening the whole image */}
        <div className='absolute inset-0 bg-[radial-gradient(ellipse_65%_55%_at_50%_45%,hsl(var(--background)/0.4),transparent_70%)]' />
      </div>

      <ParticleField quantity={26} />

      <div className='container relative z-10 flex flex-col items-center pt-24 text-center'>
        <motion.span
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className='text-overline mb-6 rounded-full border border-border/60 bg-card/40 px-4 py-1.5 backdrop-blur-md'
        >
          Nigeria&apos;s Plastic Recovery Network
        </motion.span>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className='font-heading text-[clamp(2.75rem,8vw,6.5rem)] font-bold leading-[1.02] tracking-tight text-foreground'
        >
          Turning Waste
          <br />
          Into{' '}
          <span className='bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent'>
            Worth
          </span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.22 }}
          className='mt-6 max-w-md text-lg text-muted-foreground'
        >
          Households, agents, and companies recovering plastic together — on Solana.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.34 }}
          className='mt-10'
        >
          <MagneticButton onClick={handleCta}>
            {user ? 'See How It Works' : 'Join the Network'}
          </MagneticButton>
        </motion.div>
      </div>
    </section>
  );
}

export default Hero;
